<template>
  <div class="panorama-container">
    <div ref="pano" class="panorama-viewer"></div>
  </div>
</template>

<script>
export default {
  name: 'PannellumTour',
  data() {
    return {
      viewer: null,
    };
  },
  mounted() {
    this.initViewer();
  },
  methods: {
    initViewer() {
      this.viewer = window.pannellum.viewer(this.$refs.pano, {
        default: {
          firstScene: 'entrance',
          sceneFadeDuration: 1000,
          autoLoad: true,
          hfov: 120 // bu yerda 120 – eng uzoqlashgan holat
        },
        scenes: {
          entrance: {
            title: this.$t('Kirish'),
            panorama: require('@/assets/muzey/darvoza/kirish.jpg'),
            hotSpots: [
              {
                pitch: 0,
                yaw: -22,
                type: "scene",
                text: "➡ " + this.$t('Kirish'),
                sceneId: "corridor"
              }
            ]
          },
          corridor: {
            title: this.$t('Kalidor'),
            panorama: require('@/assets/muzey/karidor/karidor.jpg'),
            hotSpots: [
              {
                pitch: -10,
                yaw: -65,
                type: "scene",
                text: "➡ " + this.$t('Memarial xona'),
                sceneId: "memorial"
              }
            ]
          },
          memorial: {
            title: this.$t('Memarial xona'),
            panorama: require('@/assets/muzey/memarial xona/memarial.jpg'),
            hotSpots: [
              {
                pitch: -10,
                yaw: -90,
                type: "scene",
                text: "➡ " + this.$t('Yoshlik xona'),
                sceneId: "youth"
              }
            ]
          },
          youth: {
            title: this.$t('Yoshlik xona'),
            panorama: require('@/assets/muzey/yoshlik xonasi/yoshlik.jpg'),
            hotSpots: [
              {
                pitch: -10,
                yaw: 145,
                type: "scene",
                text: "➡ " + this.$t('Shashmaqom xona'),
                sceneId: "shashmaqom"
              }
            ]
          },

          shashmaqom: {
            title: this.$t('Shashmaqom xona'),
            panorama: require("@/assets/muzey/shshmaqom/shashmaqom.jpg"),
            hotSpots: [
              {
                pitch: -10,
                yaw: 80,
                type: "scene",
                text: "➡ " + this.$t('Adabiyot xonasi'),
                sceneId: "literature"
              }
            ]
          },

          literature: {
            title: this.$t('Adabiyot xonasi'),
            panorama: require("@/assets/muzey/abadiyat xonasi/adabiyot.jpg"),
            hotSpots: [
              {
                pitch: -10,
                yaw: 44,
                type: "scene",
                text: "➡ " + this.$t('San’at xonasi'),
                sceneId: "art"
              }
            ]
          },


          art: {
            title: this.$t("San'at xonasi"),
            panorama: require("@/assets/muzey/sanat xonasi/sanat.jpg"),
            hotSpots: [
              {
                pitch: -0.1,
                yaw: -10,
                type: "scene",
                text: "➡ " + this.$t('Zina'),
                sceneId: "stairs"
              }
            ]
          },

          stairs: {
            title: this.$t('Zina'),
            panorama: require("@/assets/muzey/zina/zina.jpg"),
            hotSpots: [
              {
                pitch: 0.2,
                yaw: 95,
                type: "scene",
                text: "➡ " + this.$t("Ko'rgazma zali"),
                sceneId: "gallery"
              }
            ]
          },

          
          gallery: {
            title: this.$t("Ko'rgazma zali"),
            panorama: require("@/assets/muzey/ko`rgazma zali/korgazma.jpg"),
            hotSpots: [
              {
                pitch: 0.2,
                yaw: 25,
                type: "scene",
                text: "➡ " + this.$t("Maruzalar xonasi"),
                sceneId: "lecture"
              }
            ]
          },


          lecture: {
            title: this.$t('Maruzalar xonasi'),
            panorama: require("@/assets/muzey/maruzalar xonasi/maruza.jpg"),
            hotSpots: [
              {
                pitch: -3,
                yaw: 104,
                type: "scene",
                text: "↩ " + this.$t("Kirishga qaytish"),
                sceneId: "entrance"
              }
            ]
          }
        }
      });
    }
  }
};
</script>

<style scoped>
.panorama-container {
  width: 100%;
  height: 100vh;
  margin-top: 110px;
}

.panorama-viewer {
  width: 100%;
  height: 100%;
  background-color: black;
}
</style>
